export enum ERegisterSteps {
  InsertPhoneNumber = 1,
  InsertNationalID = 2,
  InsertPassword = 3
}
